import { FC } from 'react'

import MobileMenuItem from '../MobileUI/MobileMenuItem'
import CategoryIcon from '../../../Catalog/CategoryIcon'
import RenderCatalogNode from './RenderCatalogNode'
import { Catalog } from '../../../../utils/types/Product'
import { IAggregateIdentifierObject } from '../../../../utils/types/aimeosApi'

interface MobileCategoryItemProps {
  category: Catalog
  productsCount: IAggregateIdentifierObject | undefined
  onCategoryClick: (category: Catalog) => void
  isActive: boolean
  categoryMediaVariant: string
  headerStyles: Record<string, string>
}

const MobileCategoryItem: FC<MobileCategoryItemProps> = ({
  category,
  productsCount,
  onCategoryClick,
  isActive,
  categoryMediaVariant,
  headerStyles,
}) => {
  const handleClick = () => {
    if (productsCount) {
      onCategoryClick(category)
    }
  }

  return (
    <MobileMenuItem
      key={category.id}
      handleClick={handleClick}
      additionalClassNames={isActive ? headerStyles['active-category-label'] : ''}
    >
      <div className={headerStyles['mobile-category-item']}>
        {categoryMediaVariant !== 'none' && (
          <CategoryIcon
            media={category.media}
            categoryName={category['catalog.label']}
            size={32}
            type={categoryMediaVariant === 'images-only' ? 'default' : undefined}
            className={headerStyles['mobile-category-icon']}
          />
        )}
        <RenderCatalogNode
          productsCount={productsCount}
          catalogLabel={category['catalog.label']}
        />
      </div>
    </MobileMenuItem>
  )
}

export default MobileCategoryItem
